// extracted by mini-css-extract-plugin
export var container = "SocialItem-module--container--60223";
export var image = "SocialItem-module--image--a6480";
export var link = "SocialItem-module--link--1948d";
export var picture = "SocialItem-module--picture--848d0";